import React, { useState, useEffect } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import { ToastError } from "../../../Components/utils/ToastMessage";
import { useNavigate } from "react-router-dom";

function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    let firstTime;
    const [subcategories, setSubcategories] = useState([]);
    const [categories, setcategories] = useState([]);
    const {
        register,
        handleSubmit,
        setValue,
        reset,
        watch,
        formState: { errors },
    } = useForm();
    const formDataInputs = watch();
    const [base64, setbase64] = useState([]);
    const categorychange = (name) => {
        const body = JSON.stringify({ categoryname: name });
        Services.Get_SubCategory_Dropdown("POST", body, token)
            .then((res) => {
                if (res.Status === 1) {
                    setSubcategories(res.categories);
                    if (props.editable && firstTime) {
                        firstTime = false;
                        reset({
                            bannertype: props.editable.bannertype,
                            type: props.editable.type,
                            subcategoryid: props.editable?.subcategoryid,
                            categoryid: `${props.editable.categoryid}-${props.editable.categoryname}`,
                        });

                        setbase64(`${props.editable.image}`);
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const getcategories = () => {
        Services.Get_all_Categories("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setcategories(res.categories);
                    if (props.editable && props.editable.type == "category") {
                        reset({
                            ...props.editable,
                            categoryid: `${props.editable.categoryid}-${props.editable.categoryname}`,
                        });
                        setbase64(`${props.editable.image}`);
                        // setValue()
                    } else {
                        categorychange(props.editable.categoryname);
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        firstTime = true;
        getcategories();
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const handleChange = (file) => {
        if (file.type === "image/png" || file.type === "image/jpeg") {
            setValue("images", file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                setbase64(reader.result);
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        } else {
            alert("please upload image in PNG and JPEG format ");
        }
    };
    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );

    const onSubmit = (data) => {
        if (!props.editable) {
            let body = {
                ...data,
                categoryid: String(data.categoryid).split("-")[0],
                categoryname: String(data.categoryid).split("-")[1],
            };
            if (data.type != "category") {
                body = {
                    ...body,
                    subcategoryid: String(data.subcategoryid).split("-")[0],
                    subcategoryname: String(data.subcategoryid).split("-")[1],
                };
            }
            let formaata = new FormData();
            Object.keys(body).forEach((key) => {
                formaata.set(key, body[key]);
            });
            if (!formDataInputs.images) {
                alert("image is required");
                return;
            }
            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.addServiceBanners}`,
                {
                    method: "POST",
                    body: formaata,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/service-banners?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        props.tableload(true);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        } else {
            let updateData = {
                categoryid: String(data.categoryid).split("-")[0],
                categoryname: String(data.categoryid).split("-")[1],
                type: data.type,
            };
            if (formDataInputs.type == "subcategory") {
                updateData = {
                    ...updateData,
                    subcategoryid: String(data.subcategoryid).split("-")[0],
                    subcategoryname: String(data.subcategoryid).split("-")[1],
                };
            }
            if (data.images) {
                updateData = {
                    ...updateData,
                    images: data.images,
                };
            }
            if (
                formDataInputs.type == "subcategory" &&
                data.subcategoryid == "NA"
            ) {
                alert("Subcategory is required");
                return;
            }
            updateData = {
                ...updateData,
                img_obj_id: props.editable.img_obj_id,
                id: props.editable._id,
            };
            let updated = new FormData();
            Object.keys(updateData).forEach((key) => {
                updated.set(key, updateData[key]);
            });
            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.updateserviceBannerImage}`,
                {
                    method: "POST",
                    body: updated,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    if (res.Status === 1) {
                        Navigate(`/service-banners?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        props.tableload(true);
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Banner" : "Add Banner"}
                        </h3>
                        <p>
                            {props.editable ? "Update Banner" : "Add Banner"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Banner Type </label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                disabled={props.editable}
                                {...register("bannertype", {
                                    required: "Banner Type is required",
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select Banner
                                </option>

                                {[...new Set(props.categoryItems)].map(
                                    (item) => (
                                        <option value={item}>{item}</option>
                                    )
                                )}
                            </select>
                            {errors?.bannertype && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.bannertype?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Type </label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("type", {
                                    required: "Type is required",
                                    onChange: (e) => {
                                        setValue("subcategoryid", "");
                                        setValue("categoryid", "");
                                    },
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select Type
                                </option>
                                <option value="category">Category</option>
                                <option value="subcategory">Subcategory</option>
                            </select>
                            {errors?.bannertype && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.bannertype?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Category Name</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                defaultValue={""}
                                {...register("categoryid", {
                                    required: "category name is required",
                                    onChange: (e) => {
                                        if (
                                            formDataInputs.type == "subcategory"
                                        ) {
                                            categorychange(
                                                String(e.target.value).split(
                                                    "-"
                                                )[1]
                                            );
                                        }
                                    },
                                })}>
                                <option value="" disabled>
                                    Select Category
                                </option>
                                {categories.map((item) => (
                                    <option
                                        value={`${item._id}-${item.categoryname}`}>
                                        {item.categoryname}
                                    </option>
                                ))}
                            </select>
                            {errors?.categoryid && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.categoryid?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    {formDataInputs.type == "subcategory" && (
                        <div className={dashboardclasses["item-image-upload"]}>
                            <label htmlFor="categoryname">
                                subcategory Name
                            </label>
                            <div className={dashboardclasses["select"]}>
                                <select
                                    defaultValue={""}
                                    {...register("subcategoryid", {
                                        required:
                                            "Subcategory name is required",
                                    })}>
                                    <option value="" disabled>
                                        Select Subcategory
                                    </option>
                                    {subcategories.map((item) => (
                                        <option
                                            value={`${item._id}-${item.subcategoryname}`}>
                                            {item.subcategoryname}
                                        </option>
                                    ))}
                                </select>
                                {errors?.subcategoryid && (
                                    <p className={dashboardclasses["error"]}>
                                        {errors?.subcategoryid?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Banner Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["uploaded-img"]}>
                        <img src={base64} alt="" width={"120px"} />
                    </div>
                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div> */}

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Banner"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
